/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterExternalInfo } from '../../models/work-center-external-info';

export interface GetWorkCenterInfoByExternalId$Params {
  externalWorkCenterId: string;
}

export function getWorkCenterInfoByExternalId(http: HttpClient, rootUrl: string, params: GetWorkCenterInfoByExternalId$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterExternalInfo>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterInfoByExternalId.PATH, 'get');
  if (params) {
    rb.path('externalWorkCenterId', params.externalWorkCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterExternalInfo>;
    })
  );
}

getWorkCenterInfoByExternalId.PATH = '/api/v1/WorkCenter/GetWorkCenterInfoByExternalId/{externalWorkCenterId}';
